import { dateOnly } from './dateUtils';
import {
  DailyAvailabilityDay,
  DailyAvailabilityLedgerEntry,
} from '../types/DailyAvailability';

export type ProductAvailabilityKind = 'default' | 'bundles' | 'addOns';

export interface DailyAvailabilityFlags {
  numberAvailable: number;
  isRentedInPeriod: boolean;
  overbooked: boolean;
}

export const getProductAvailabilityKind = (
  productTypeKey: string
): ProductAvailabilityKind => {
  if (productTypeKey === 'bundles') {
    return 'bundles';
  }
  if (productTypeKey === 'addOns') {
    return 'addOns';
  }
  return 'default';
};

export const isAddOnRentedOnDate = (
  ledgerEntries: DailyAvailabilityLedgerEntry[] | undefined,
  dateTimestamp: string
): boolean =>
  Boolean(
    ledgerEntries?.length &&
      ledgerEntries.some(
        (entry) => dateOnly(entry.date) === dateOnly(dateTimestamp)
      )
  );

export const computeDailyAvailabilityFlags = (
  availabilityData: DailyAvailabilityDay,
  dateTimestamp: string,
  productTypeKey: string
): DailyAvailabilityFlags => {
  const {
    available,
    unavailable,
    maintenance,
    ledgerEntries,
    inUse,
    rawAvailableCount = 0,
  } = availabilityData;

  const numberAvailable = available - (maintenance || 0);
  let isRentedInPeriod = unavailable > 0;
  let overbooked = numberAvailable < 0;

  const kind = getProductAvailabilityKind(productTypeKey);

  if (kind === 'bundles') {
    isRentedInPeriod = Boolean(inUse);
    overbooked = rawAvailableCount < 0;
  } else if (kind === 'addOns') {
    isRentedInPeriod = isAddOnRentedOnDate(ledgerEntries, dateTimestamp);
  }

  return { numberAvailable, isRentedInPeriod, overbooked };
};
